<div class="entities-view-wrapper">
  <div class="entities-search-bar">
    <div class="search-input-container">
      <fa-icon [icon]="icons.faSearch" class="search-icon"></fa-icon>
      <input type="text" [(ngModel)]="filterText" (ngModelChange)="onFilterChange($event)"
        [placeholder]="'SEARCH.PLACEHOLDER.ENTITIES' | translate" class="filter-input" />
      @if (filterText) {
      <button class="clear-btn" (click)="clearFilter()">
        <fa-icon [icon]="icons.faTimes"></fa-icon>
      </button>
      }
    </div>
    @if (showDownloadButton) {
    <button class="download-entities-btn" (click)="download.emit()" [title]="'RESULT.DOWNLOAD_JSON' | translate">
      <fa-icon [icon]="icons.faDownload"></fa-icon>
    </button>
    }
    @if (showSaveReferenceButton) {
    <button
      class="save-reference-btn"
      [disabled]="!canSaveReference"
      (click)="saveReference.emit()"
      [title]="'REFERENCES.SAVE_BUTTON' | translate">
      <fa-icon [icon]="icons.faBookmark"></fa-icon>
    </button>
    }
  </div>

  <div class="entities-compact-list">
    @for (item of filteredItems; track trackByItem($index, item)) {
    @if (item.type === 'object') {
    <div class="entity-group-compact" [id]="'object-group-' + $index">
      <div class="group-name">
        {{ item.formattedLabel }}
        @if (item.totalInGroup && item.totalInGroup > 1) {
        <span class="group-counter">({{ item.indexInGroup }})</span>
        }
      </div>
      <div class="group-items">
        @for (key of getObjectKeys(asObject(item.data).values); track key) {
        <div class="entity-item">
          <span class="item-label">{{ formatLabel(key) }}:</span>
          <div class="item-values">
            @for (value of asObject(item.data).values[key]; track trackByValue($index, value)) {
            <div class="item-value" [id]="'entity-item-' + value.id" [class.selected]="isEntitySelected(value.id)"
              (click)="onEntityClick(value.id)">
              <span class="val-text">{{ value.text }}</span>
              @if (showConfidence) {
              <span class="val-conf" [style.color]="getConfidenceColor(value.relation_score || 0)">
                {{ getProbabilityPercent(value.relation_score) }}%
              </span>
              }
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }

    @if (item.type === 'entity') {
    <div class="entity-item-standalone" [id]="'entity-item-' + asEntity(item.data).id"
      [class.selected]="isEntitySelected(asEntity(item.data).id)" (click)="onEntityClick(asEntity(item.data).id)">
      <span class="item-label">
        {{ item.formattedLabel }}
        @if (item.totalInGroup && item.totalInGroup > 1) {
        <span class="item-counter">({{ item.indexInGroup }})</span>
        }
        :</span>
      <span class="val-text">{{ asEntity(item.data).text }}</span>
      @if (showConfidence) {
      <span class="val-conf" [style.color]="getConfidenceColor(asEntity(item.data).probability || 0)">
        {{ getProbabilityPercent(asEntity(item.data).probability) }}%
      </span>
      }
    </div>
    }
    } @empty {
    <div class="no-filter-results">
      <p>{{ 'MESSAGE.NO.ENTITIES' | translate }}</p>
    </div>
    }
  </div>
</div>